<template>
  <component
    :is="component"
    :key="getId"
    ref="component"
    :section-info="sectionInfo"
    :thumbnail-info="getThumbnailInfo()"
    :multisection-index="multisectionIndex"
  />
</template>
<script>
  import {
    getThumbnailInfo,
    isFalsy,
    isProductMode,
  } from '@/common/utils/common'
  import _ from 'lodash'
  import fp from 'lodash/fp'
  import { getSectionEventObject } from '@/common/utils/gnb.fp'

  export default {
    name: 'DynamicSectionLoader',
    props: {
      sectionInfo: {
        type: Object,
      },
      multisectionIndex: {
        type: Number,
      },
    },
    data() {
      return {
        component: null,
      }
    },
    computed: {
      getId() {
        return fp.flow(
          fp.getOr([], 'eventlist'),
          getSectionEventObject,
          fp.getOr('', ['onContent', 'url']),
        )(this.sectionInfo)
      },
      loader() {
        if (
          isFalsy(this.sectionInfo) ||
          isFalsy(_.get(this.sectionInfo, 'cell_type', ''))
        )
          return null
        const cellType = _.get(this.sectionInfo, 'cell_type', '')
        let componentName = ''
        switch (cellType) {
          case 'band_1':
          case 'band_2':
          case 'band_3':
          case 'band_4':
          case 'band_5':
          case 'band_6':
          case 'band_7':
          case 'band_8':
          case 'band_9':
          case 'band_10':
          case 'band_11':
          case 'band_12':
          case 'band_13':
          case 'band_14':
          case 'band_15':
          case 'band_16':
          case 'band_17':
          case 'band_18':
          case 'band_19':
          case 'band_20':
          case 'band_21':
          case 'band_42':
          case 'band_61':
          case 'band_71':
          case 'band_94':
          case 'band_98':
          case 'band_myview':
            componentName = 'TemplateMultiSection'
            break
          case 'band_30':
            componentName = 'TemplateKeywordBandLine2'
            break
          case 'band_31':
            componentName = 'TemplateLauncher'
            break
          case 'band_43':
            componentName = 'TemplateKboScheduleResult'
            break
          case 'band_48':
            componentName = 'TemplateKboTeamRank'
            break
          case 'band_49':
            componentName = 'TemplateKboPlayerRank'
            break
          case 'band_52':
            componentName = 'TemplateLiveChannelList'
            break
          case 'band_82':
            componentName = 'TemplatePreview'
            break
          case 'band_99':
            componentName = 'Band99'
            break
          case 'blank_10':
            componentName = 'TemplateEmptySpace'
            break
          case 'banner_1':
            componentName = 'TemplateMultiBanner'
            break
          case 'banner_2':
            componentName = 'TemplateSingleBanner'
            break
          case 'titleonly':
            componentName = 'TitleOnly'
            break
          case 'mainlist':
          case 'popularlist':
          case 'newlist':
          case 'clipPopularProgramList':
            componentName = 'Smr'
            break
          case 'band_24':
            componentName = 'CategoryMenuGroup'
            break
          case 'band_category_layer':
            componentName = 'CategoryMenuLayerGroup'
            break
          case 'user_info':
            componentName = 'TemplateUserInfo'
            break
          // case 'band_71' :
          //   componentName = 'TemplateEditorPick'
          //   break
          case 'banner_text':
            componentName = 'TemplateBigBanner'
            break
          case 'band_highlight':
            componentName = 'HighlightBand'
            break
          case 'ERROR':
            componentName = isProductMode ? 'TemplateEmptySpace' : 'Error'
            break
          default:
            // eslint-disable-next-line no-console
            console.log('error CellType : ', cellType)
        }
        return () => import(`./multisection/${componentName}`)
      },
    },
    mounted() {
      this.loader()
        .then(() => {
          this.component = () => this.loader()
        })
        .catch(() => {
          this.component = () => import('./template/Error')
        })
    },
    beforeDestroy() {
      _.get(this, ['$refs.component.$destroy'], function () {})()
    },
    methods: {
      getThumbnailInfo() {
        const cellType = _.get(this.sectionInfo, 'cell_type')
        if (cellType === '') return
        return getThumbnailInfo(cellType)
      },
    },
  }
</script>
